import axios from 'axios'
import { BASE_URL } from '../../utils/constants/url'
import generalHeader from '../../utils/constants/generalHeader'

// This endpoint's DTO types `platform` as the numeric RegistrationSource enum
// (stats=0, fans=1, web=2, stream=3) and `email` as a plain string — unlike
// /auth/register, which accepts the "web" string. Send the shape it expects.
const WEB_PLATFORM = 2

const resendConfirmationEmail = (email) => {
  const url = `${BASE_URL}/auth/send-confirmation-email`
  const clientData = { email, platform: WEB_PLATFORM }

  return axios.post(url, clientData, {
    headers: generalHeader(),
  })
}

export default resendConfirmationEmail
